import { stringify } from 'query-string';

import { Role, UserField } from '../models';
import { Network } from '../utils';

const fields: string = [UserField.EMAIL, UserField.FIRST_NAME, UserField.LAST_NAME, UserField.ROLES].join(',');

export const getUsers = async filters => {
  const queryParams = {
    ...filters,
    fields,
    s: JSON.stringify(filters.s),
    join: ['store'],
  };
  return Network.get(`users?${stringify(queryParams)}`);
};
export const deleteUser = async id => Network.delete(`users/${id}`);
export const addUser = async user => {
  if (!user?.store?.id) {
    delete user?.store;
  }
  if (user?.roles.includes(Role.APP_ADMIN)) {
    delete user?.store;
  }
  return Network.post('users', user);
};
export const editUser = async (id, user) => await Network.patch(`users/${id}`, user);

